<template>
  <v-container fluid>
    <ContentHeader
      header-title="New Vendor Onboarding Management"
      back-navigation
      back-navigation-to="/client/manage/onboard"
    ></ContentHeader>
    <PtSheet>
      <WorkflowVendorSummary
        v-if="summaryLoaded"
        :covg-summary="summary"
        :fluid="true"
      />
      <v-row>
        <v-col class="text-right">
          <!--TODO change this to signup complete-->
          <v-dialog
            v-if="!this.summary.signupComplete"
            v-model="showResendInviteDialog"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                outlined
                color="primary"
                class="mx-1"
                @click="showResendInviteDialog = true"
                >Resend Invite Email
              </v-btn>
            </template>
            <div class="d-flex justify-center">
              <v-card width="500">
                <v-card-title>Resend Invite Email</v-card-title>
                <v-card-text>
                  <v-text-field
                    v-model="resendInviteEmailAddress"
                    :rules="[rules.required(), rules.email]"
                    dense
                    filled
                    label="Resend Email Invite Address*"
                  ></v-text-field>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="showResendInviteDialog = false">
                    Close
                  </v-btn>
                  <blue-call-to-action @click="resendEmail">
                    Send Email
                  </blue-call-to-action>
                </v-card-actions>
              </v-card>
            </div>
          </v-dialog>
          <v-dialog v-if="this.summary.exportable" v-model="showExportDialog">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                outlined
                color="primary"
                class="mx-1"
                @click="showExportDialog = true"
                >Export
              </v-btn>
            </template>
            <div class="d-flex justify-center">
              <v-card width="500">
                <v-card-title>Export</v-card-title>
                <v-card-text
                  >This vendor will be exported at your regularly scheduled
                  export time. Click OK to schedule the export.
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="showExportDialog = false">
                    Cancel
                  </v-btn>
                  <blue-call-to-action @click="attemptExport">
                    OK
                  </blue-call-to-action>
                </v-card-actions>
              </v-card>
            </div>
          </v-dialog>
        </v-col>
      </v-row>
      <WorkflowTable :covg-id="covgId" />
    </PtSheet>
  </v-container>
</template>

<script>
import * as rules from "@/services/rules";
import ContentHeader from "@/views/ContentHeader.vue";
import PtSheet from "@/components/PtSheet.vue";
import WorkflowTable from "@/views/client/WorkflowTable.vue";
import WorkflowVendorSummary from "@/views/client/WorkflowVendorSummary.vue";
import BlueCallToAction from "@/components/providertrust/buttons/BlueCallToAction";
import { get, post } from "@/services/request";
import {
  vendorOnboardingExportAPI,
  workflowVendorSummaryAPI,
  resendInviteEmailAPI
} from "@/services/api";
import hasNotifications from "@/mixins/has-notifications";

export default {
  name: "WorkflowPage",
  components: {
    WorkflowVendorSummary,
    WorkflowTable,
    PtSheet,
    ContentHeader,
    BlueCallToAction
  },
  mixins: [hasNotifications],
  props: ["covgId"],
  data() {
    return {
      showExportDialog: false,
      showResendInviteDialog: false,
      resendInviteEmailAddress: null,
      rules,
      summary: {}
    };
  },
  created() {
    this.loadSummary();
  },
  computed: {
    summaryLoaded() {
      return this.summary.creationDate;
    }
  },
  methods: {
    loadSummary() {
      get(workflowVendorSummaryAPI.getUrl({ covgId: this.covgId })).then(
        response => {
          if (response && response.data) {
            this.summary = response.data;
          }
        }
      );
    },
    attemptExport() {
      post(vendorOnboardingExportAPI.getUrl({ covgId: this.covgId })).then(
        response => {
          if (response) {
            if (response.data) {
              this.showMessage({
                text: "Export has been scheduled",
                mode: "success"
              });
            } else {
              this.showMessage({
                text:
                  "Export failed. This likely means that the vendor record does not match" +
                  " the necessary configuration to be eligible for export.",
                mode: "error"
              });
            }
          }
        }
      );
      this.showExportDialog = false;
    },
    resendEmail(emailAddress) {
      if (emailAddress == null || emailAddress.length < 3) {
        this.showMessage({
          text: "Please specify an email address for the invite email",
          mode: "error"
        });
      }

      post(resendInviteEmailAPI.getUrl({ covgId: this.covgId }), {
        emailAddress: this.resendInviteEmailAddress
      }).then(
        response => {
          if (response) {
            if (response.data) {
              this.showMessage({
                text: "An invite has been sent",
                mode: "success"
              });
            } else {
              this.showMessage({
                text: "Unable to resend the email",
                mode: "error"
              });
            }
          }
        },
        () => {
          this.showMessage({
            text: "Unable to resend the email",
            mode: "error"
          });
        }
      );

      this.showResendInviteDialog = false;
    }
  }
};
</script>

<style scoped></style>
